module.exports = __webpack_public_path__ + "static/media/1on1-inactive.1dca57e1.svg";